document.addEventListener("DOMContentLoaded", function () {
  const subcollectionsSwiper = document.querySelector(
    ".collection__subcollection[data-subcollections-swiper]"
  );

  if (subcollectionsSwiper) {
    const swiper = new Swiper(subcollectionsSwiper, {
      slidesPerView: 3.5,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          spaceBetween: 16,
        },
      },
    });
  }
});